import { useCallback } from 'react';
import { getStore } from '../store/store';
import { isPrivateSectorEnabled, usePrivateSectorFlag } from './featureFlags';

/**
 * Product copy for areas of responsibility. Data, ids, and API fields stay AOR
 * either way.
 */
export function relabelAorText(value: string): string {
  return value
    .replaceAll('Area of Responsibility (AOR)', 'Business Unit')
    .replaceAll('AOR (Area of Responsibility)', 'Business Unit')
    .replaceAll('Areas of Responsibility', 'Business Units')
    .replaceAll('Area of Responsibility', 'Business Unit')
    .replaceAll('AORs', 'Business Units')
    .replaceAll(/\ban AOR\b/g, 'a Business Unit')
    .replaceAll(/\bAOR\b/g, 'Business Unit');
}

export function relabelAorTextIf(
  value: string,
  privateSector: boolean
): string {
  return privateSector ? relabelAorText(value) : value;
}

export function relabelAorTextFromStore(value: string): string {
  const flags = getStore().getState().app.featureFlags as string[] | undefined;
  return relabelAorTextIf(value, isPrivateSectorEnabled(flags));
}

export function useAorText(): (value: string) => string {
  const privateSector = usePrivateSectorFlag();
  return useCallback(
    (value: string) => relabelAorTextIf(value, privateSector),
    [privateSector]
  );
}
